import React, { Component } from "react";


function Subfooter() {
  return (
    <div>
      <button onClick="topFunction()" id="myBtn" title="Go to top">Top</button>
      

    </div>
  )
}

export default Subfooter
